import React from "react";
import css from "./style.scss";
import store from 'utils/store';
import cn from 'classnames';

export default class Toast extends React.Component {
  constructor(props){
    super(props)
    this.state={
      alreadyHidden:false
    }
  }
  onClick=()=>{
    if(this.props.onClick){
      this.hideToast()
      this.props.onClick()
    }
  }
  render(){
    return (
      <div onClick={this.onClick} className={cn(css.toast, this.props.important ? css.important : "")}>
        {this.props.children}
      </div>
    )
  }
  hideToast=()=>{
    if(!this.state.alreadyHidden){
      this.setState({alreadyHidden:true})
      store.dispatch({type:"REMOVE_TOAST", payload:this.props.id})
    }
  }
  componentWillUnmount(){
    if(this.timeout) {
      clearTimeout(this.timeout)
    }
  }
  componentDidMount(){
    if(this.props.duration!==-1){
      this.timeout=setTimeout(this.hideToast, this.props.duration || 5000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/toast/toast.js